module.exports = __webpack_public_path__ + "static/media/11.f37d0d5a.png";